import Sidebar from '@Components/Navigations/Sidebar'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import ExpandableItem from '@Components/Navigations/Sidebar/ExpandableItem'
import { ICONS } from '@Const/common'
import Navigation from '@App/navigation'
import { NavLink } from 'react-router'
import './index.scss'

const SongwriterSubNavigation = () => {
    const { songwriterStore } = useContext(StoresContext)

    return (
        <Sidebar>
            <ExpandableItem
                heading="Song Catalog"
                icon={ICONS.catalog}
                link={Navigation.songwriter.catalog.root(songwriterStore.currentSongwriterId)}
            >
                <NavLink to={Navigation.songwriter.myWriters(songwriterStore.currentSongwriterId)}>
                    My Writer Names
                </NavLink>
                <NavLink to={Navigation.songwriter.cowriterSearch(songwriterStore.currentSongwriterId)}>
                    Co-Writers
                </NavLink>
                <NavLink to={Navigation.songwriter.catalogBuilder(songwriterStore.currentSongwriterId)}>
                    Catalog Builder
                </NavLink>
            </ExpandableItem>

            <ExpandableItem className="songwriter-matching-tool-nav" heading="Matching" icon={ICONS.linkIcon}>
                <NavLink to={Navigation.songwriter.matchingTool(songwriterStore.currentSongwriterId)}>
                    Matching Tool
                </NavLink>
                <NavLink to={Navigation.songwriter.matchingHistory(songwriterStore.currentSongwriterId)}>
                    Match History
                </NavLink>
            </ExpandableItem>
        </Sidebar>
    )
}

export default SongwriterSubNavigation
